import { useCallback, useContext, useMemo } from 'react'

import { faEdit } from '@fortawesome/pro-solid-svg-icons'
import { useSelector } from 'react-redux'

import useQuota from '../../../../utils/api/hooks/useQuota'
import { QuotaFormModalContext, Types } from '../../../../Providers/Forms/QuotaForm/QuotaFormModalProvider'
import { Action, ActionTypes, GlobalDeleteAction } from '../../../../Components/antd/Tables/DataTable/utils/actions'
import ActionsRow from '../../../../Components/antd/Lists/ActionsRow'
import { firstOrDefault, isNonEmptyArray } from '../../../../utils'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import { selectUser } from '../../../../reducers/UserReducer'
import { ColorsPalette } from '../../../../config/colors'
import { isSchoolUser } from '../../../../utils/roles'
import { getFormType } from '../../../../Components/shared/Quotas/utils'

const QuotaToolBar = ({ selectedQuotas = [], onChange, onUnselect }) => {
  const { setFormHandler } = useContext(QuotaFormModalContext)

  const user = useSelector(selectUser)
  const t = useSelector(selectTranslate)

  const quotaHandler = useQuota({ callback: onChange })

  const handleEditClick = useCallback((quotas, isSchoolUser) => {
    setFormHandler(handler => ({
      ...handler,
      data: firstOrDefault(selectedQuotas),
      callback: quotaHandler.update,
      type: isSchoolUser ? Types.QUOTA : getFormType(firstOrDefault(selectedQuotas))
    }))
  }, [selectedQuotas, setFormHandler, quotaHandler.update])

  const actions = useMemo(() => {
    const isEditable = selectedQuotas.length === 1 && (!isSchoolUser(user) || !selectedQuotas.some(quota => !quota.isDesiderata))

    return [
      new Action({
        title: t('quota_table_menu.buttons.edit_quota'),
        className: () => 'mr-4',
        ghost: true,
        icon: faEdit,
        type: ActionTypes.GLOBAL,
        color: isEditable ? ColorsPalette.BLUE_ICON : ColorsPalette.LIGHT_GREY,
        disabled: !isEditable,
        onClick: quotas => handleEditClick(quotas, isSchoolUser(user))
      }),
      new GlobalDeleteAction({
        title: t('quota_table_menu.buttons.delete_quota'),
        disabled: !isNonEmptyArray(selectedQuotas) || (isSchoolUser(user) && selectedQuotas.some(quota => !quota.isDesiderata)),
        ghost: true,
        onDelete: () => quotaHandler.delete(selectedQuotas)
      })
    ]
  }, [selectedQuotas, handleEditClick, quotaHandler.delete, user])

  return (
    <div className='z-500'>
      <ActionsRow
        actions={actions}
        buttonTitle={t('quota_toolbar.button_title', { numberOfQuotas: selectedQuotas.length })}
        buttonTooltipTitle={t('quota_toolbar.button_tooltip_title')}
        data={selectedQuotas}
        onUnselect={onUnselect}
      />
    </div>
  )
}

export default QuotaToolBar
